var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "el-section" }, [
    _c(
      "div",
      {
        staticClass:
          "emd-container _highlight_header _header_spaced _footer_spaced_sm",
      },
      [
        _c("div", { staticClass: "emd-container__header" }, [
          _c("h2", { staticClass: "emd-text _size_section" }, [
            _vm._v(" " + _vm._s(_vm.$t("subscription.list.title")) + " "),
          ]),
          _vm.canShowShop
            ? _c(
                "a",
                {
                  staticClass: "emd-btn _color_primary _size_small",
                  attrs: {
                    target: "_blank",
                    rel: "noopener noreferrer",
                    id: "link-shop-subscriptions",
                    href: _vm.$sanitize(_vm.urlShop),
                  },
                  on: { click: _vm.shopTrack },
                },
                [_vm._v(" " + _vm._s(_vm.$t("subscription.btn-create")) + " ")]
              )
            : _vm._e(),
        ]),
        _vm._t("default"),
        _vm.loadingListSubscriptions
          ? _c(
              "section",
              { staticClass: "eu-pa_6 eu-align_center" },
              [_c("emd-loader", { attrs: { type: "_invert" } })],
              1
            )
          : _c(
              "section",
              { staticClass: "emd-table-responsive" },
              [
                _c("Table", {
                  attrs: {
                    fields: _vm.fields,
                    items: _vm.items,
                    toDetail: _vm.detail,
                  },
                }),
                _vm.showEmptyList
                  ? _c("empty-list", {
                      attrs: {
                        entity: _vm.emptyData.entity,
                        svg: _vm.emptyData.svg,
                      },
                    })
                  : _vm._e(),
                _vm.showEmptyListFilter
                  ? _c("empty-list-filter", {
                      attrs: { entity: "subscriptions" },
                    })
                  : _vm._e(),
              ],
              1
            ),
        !_vm.loadingListSubscriptions
          ? _c("pagination", {
              attrs: {
                type: "list",
                action: _vm.action,
                pagination: _vm.pagination,
                totalShowing: _vm.totalItems,
              },
            })
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }